import React, { useState, useEffect, useCallback } from "react";
import "./Carousel.css";

export default function Carousel(props) {
    const { children, show = 1 } = props;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [length, setLength] = useState(children.filter((child) => child !== false).length);
    const [touchPosition, setTouchPosition] = useState(null);
    const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);

    const next = useCallback(() => {
        if (currentIndex < length - show) {
            setCurrentIndex((prevState) => prevState + 1);
        } else {
            setCurrentIndex(0);
        }
    }, [currentIndex, length, show]);

    const prev = useCallback(() => {
        setAutoScrollEnabled(false);
        if (currentIndex > 0) {
            setCurrentIndex((prevState) => prevState - 1);
        } else {
            setCurrentIndex(length - show);
        }
        setTimeout(() => {
            setAutoScrollEnabled(true);
        }, 500);
    }, [currentIndex, length, show]);

    const handleTouchStart = (e) => {
        const touchDown = e.touches[0].clientX;
        setTouchPosition(touchDown);
    };

    const handleTouchMove = (e) => {
        const touchDown = touchPosition;
        if (touchDown === null) {
            return;
        }
        const currentTouch = e.touches[0].clientX;
        const diff = touchDown - currentTouch;
        if (diff > 5) {
            next();
        }
        if (diff < -5) {
            prev();
        }
        setTouchPosition(null);
        setAutoScrollEnabled(false);
        setTimeout(() => {
            setAutoScrollEnabled(true);
        }, 500);
    };

    useEffect(() => {
        setLength(children.filter((child) => child !== false).length);
    }, [children]);

    useEffect(() => {
        if (autoScrollEnabled) {
            const intervalId = setInterval(next, 5000);
            return () => {
                clearInterval(intervalId);
            };
        }
    }, [autoScrollEnabled, next]);

    return (
        <div className="carousel-container">
            <div className="carousel-wrapper">
                <button className="left-arrow" onClick={prev}>
                    arrow_back_ios_new
                </button>
                <div className="carousel-content-wrapper" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
                    <div className="carousel-content" style={{ transform: `translateX(-${(currentIndex * 100) / show}%)`, "--show": show }}>
                        {children
                            .filter((child) => child !== false)
                            .map((child, index) => (
                                <div key={index} className="carousel-content-package" style={{ "--carousel-id": index }}>
                                    {child}
                                </div>
                            ))}
                    </div>
                </div>
                <button className="right-arrow" onClick={next}>
                    arrow_forward_ios
                </button>
            </div>
        </div>
    );
}
